
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// TODO: Replace with your app's Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyAm8EKCY3XGb8Vl9QfHiOT7i7hX0ubItww",
  authDomain: "somoacademic.firebaseapp.com",
  databaseURL: "https://somoacademic-default-rtdb.firebaseio.com",
  projectId: "somoacademic",
  storageBucket: "somoacademic.firebasestorage.app",
  messagingSenderId: "146052308243",
  appId: "1:146052308243:web:ca1cbd1c459b40bddf8ee6",
  measurementId: "G-RJJFQQ456N"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get Firebase services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);

export { app, auth, db, storage, functions };
